import classNames from "classnames";
import { RectangleSpinner } from "../../../../common/spinners";
import _ from "lodash";
import moment from "moment";
import React, { PropTypes } from "react";
import { ButtonToolbar, OverlayTrigger, Tooltip } from "react-bootstrap";
import { FormattedMessage, intlShape } from "react-intl";
import { connect } from "react-redux";
import { Link } from "react-router";
import { bindActionCreators } from "redux";
import { SubmissionError } from "redux-form";

import { CheckboxButton, EditButton, Render } from "../../../../common";
import { DataTable } from "../../../../common/DataTable";
import { BasicMemberFields, BillingPeriodFilter } from "./";
import { MemberCoverageStatus } from "./member/coverage/";

import * as types from "../../../../../utils/data/dataActionTypes";
import * as dataActions from "../../../../../utils/data/dataActions";
import { BILLING_PERIODS, CLIENTS, MEMBERS, MEMBER_TABLE } from "../../../../../utils/data/models";
import * as downloaderActions from "../../../../../utils/downloader/downloaderActions";
import * as selectedConfirmationMembersActions from "./SelectedMembersForConfirmationActions";

import {
    PLAN_ADMINISTRATOR,
    AGENT,
    HIGH_MANAGEMENT_WITH_FINANCE,
    DIRECTOR,
    MANAGER,
    ADMINISTRATOR,
    FINTECH,
    HR_CLERK
} from "../../../../../utils/Roles";
import { toast } from "react-toastify";
import englishTranslations from "../../../../../components/intl/en-CA";
import frenchTranslations from "../../../../../components/intl/fr-CA";
import { downloaderEnums } from "../../../../../utils/downloader/downloaderEnums";
import userHasAccess from "../../../../../utils/userHasAccess";
import { canDownload } from "../../../../common/CanDownload";
import { MANUAL, RECURRING } from "../../enums/billingPeriodTypes";
import { GM, PM } from "../../enums/businessAccountTypes";
import { ACTIVE, IMPLEMENTATION, INACTIVE, TERMINATED, RESTRICTED_STATUSES } from "../../enums/clientStatusTypes";
import * as clientActions from "../clientActions";
import GenerateCoverageConfirmationButton from "./GenerateCoverageConfirmationButton";
import GenerateMajorCardButton from "./GenerateMajorCardButton";
import MembersGenerateCoverageModal from "./MembersGenerateCoverageModal";
import { canViewSyncStatus, getLatestMemberSyncsV2, getOverlayForSync } from "../../../../common/synchronization/SynchronizationHelper";
import { MEMBER } from "../../../synchronization/enums/syncElementTypes";
import { getBatchMemberActivationStatuses } from "../../../../../utils/services/memberActivationStatusService";
import { canViewActivationStatus } from "../../../../common/MemberActivation/memberActivationHelper";
import { TED_DESJARDINS } from "../../enums/synchronizationOptions";

const NEW_MEMBERS = "NEW_MEMBERS";
const memberPageSize = 25;

class MembersDataTable extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.checkboxes = {};

        this.state = {
            filters: props.filters,
            selection: [],
            downloadPath: null,
            showConfirmationCoverageModal: false,
            latestSyncs: null,
            activationStatuses: null
        };
        this.toastId = null;
        this.confirmationCheckboxes = {};
        this.createMember = this.createMember.bind(this);
        this.setCellClassNames = this.setCellClassNames.bind(this);
        this.toggleArchivedMembers = this.toggleArchivedMembers.bind(this);
        this.updateMember = this.updateMember.bind(this);
        this.getData = this.getData.bind(this);
        this.updateBillingPeriodFilter = this.updateBillingPeriodFilter.bind(this);
        this.toggleAllCheckboxes = this.toggleAllCheckboxes.bind(this);
        this.updateMasterCheckbox = this.updateMasterCheckbox.bind(this);
        this.generateMajorCards = this.generateMajorCards.bind(this);
        this.onDownloadComplete = this.onDownloadComplete.bind(this);
        this.isSelected = this.isSelected.bind(this);
        this.getMemberName = this.getMemberName.bind(this);
        this.selectedBillingPeriod = null;
        this.handleMemberCheckBox = this.handleMemberCheckBox.bind(this);
        this.verifyCheckedMember = this.verifyCheckedMember.bind(this);
        this.getMembersConfirmationCountForPeriod = this.getConfirmationMembersForPeriod.bind(this);
        this.clearMembersForConfirmation = this.clearMembersForConfirmation.bind(this);
        this.toggleInactivatedMembers = this.toggleInactivatedMembers.bind(this);
        this.getCanModifyOrCreateForClientStatusType = this.getCanModifyOrCreateForClientStatusType.bind(this);

        this.canModifyOrCreateForImplementation = userHasAccess(HIGH_MANAGEMENT_WITH_FINANCE, true);
        this.canModifyOrCreateForActive = userHasAccess(
            [DIRECTOR, MANAGER, AGENT, PLAN_ADMINISTRATOR, ADMINISTRATOR, FINTECH, HR_CLERK],
            true
        );
        this.canModifyOrCreateForTerminated = userHasAccess(FINTECH);
    }

    componentWillMount() {
        this._initializePage();
        // MINT status is now fetched at the ClientPage level and stored in Redux
    }

    componentWillReceiveProps(nextProps) {
        this.setState({ filters: nextProps.filters });
    }

    componentDidUpdate(prevProps) {
        // Check if clientId changed and reload data if it did
        if (prevProps.clientId !== this.props.clientId) {
            this._initializePage();
        }

        if (this.state.downloadPath) {
            if (this.props.successDownloads.length > 0) {
                let finishedDownloadObj = this.props.successDownloads.find(
                    (download) => download.path == this.state.downloadPath
                );

                if (finishedDownloadObj) {
                    this.setState({ downloadPath: null });

                    this.onDownloadComplete(finishedDownloadObj);
                }
            }
            if (this.props.errorDownloads.length > 0) {
                let finishedDownloadObj = this.props.errorDownloads.find(
                    (download) => download.path == this.state.downloadPath
                );

                if (finishedDownloadObj) {
                    this.setState({ downloadPath: null });
                    this.onDownloadComplete(finishedDownloadObj);
                }
            }
        }
    }

    componentWillUnmount() {
        this.clearMembersForConfirmation();
    }

    _initializePage() {
        this.props.dataActions.clearDataList(MEMBERS);
        this.props.dataActions.clearDataList(MEMBER_TABLE);
        this.props.dataActions.clearDataList(BILLING_PERIODS);
        this.setState({ selection: [] });

        const fields = "billingPeriodId,endDate,startDate,localizations";
        const filters = [`billingPeriods.clientId==${this.props.clientId}`];

        this.props.dataActions
            .getDataList(BILLING_PERIODS, 0, 0, "", ["startDate:desc"], filters, null, {}, fields)
            .then((data) => {
                this.updateBillingPeriodFilter({
                    target: {
                        value: data.payload.data.items.length ? data.payload.data.items[0].billingPeriodId : null,
                    },
                });
            });
    }

    createMember(values) {
        return this.props.dataActions
            .createDataItem(MEMBERS, {
                ...values,
                clientId: values.client.clientId,
                isEditable: true,
                languageCode: "fr-CA",
            })
            .then((data) => {
                if (data.type === types.CREATE_DATA_ITEM_FAILURE)
                    if (data.payload.error.data.error === "duplicateMemberIdentifier") {
                        throw new SubmissionError({
                            memberIdentifier: {
                                messageKey: "validation.customMessages.serverErrors.duplicateMemberIdentifier",
                                values: {},
                                state: "error",
                            },
                        });
                    } else if (data.payload.error.data.error === "noMemberIdentifier") {
                        toast(<FormattedMessage id="validation.memberValidation.noMemberIdentifier" />, {
                            type: toast.TYPE.ERROR,
                            autoClose: false,
                        });
                        throw new SubmissionError({
                            firstName: {
                                messageKey: "validation.memberValidation.noMemberIdentifier",
                                values: {},
                                state: "error",
                            },
                        });
                    } else if (data.payload.error.data.error === "noClientNumber") {
                        throw new SubmissionError({
                            firstName: {
                                messageKey: "validation.memberValidation.noClientNumber",
                                values: {},
                                state: "error",
                            },
                        });
                    } else {
                        this.getData(
                            this.props.offset,
                            this.props.limit,
                            this.props.q,
                            this.props.sortBy,
                            this.state.filters
                        );
                    }
            });
    }

    onDownloadComplete(data) {
        this.props.dataActions.clearDataFile(MEMBERS);
        this.setState({ response: data.extraData });
        this._initializePage();

        if (data.error) {
            toast.dismiss();
            toast(<FormattedMessage id={`members.member.errors.${data.message}`} />, {
                type: toast.TYPE.ERROR,
                autoClose: false,
            });
        }
        if (data.extraData) {
            const failed = Object.entries(data.extraData).filter((k_v) => {
                if (k_v[1] != "SUCCESS") return k_v[0];
            });

            if (failed.length) {
                toast.dismiss();
                failed.forEach((memberId) => {
                    toast(
                        memberId.length < 2 ? (
                            <FormattedMessage id={`members.member.actions.error`} />
                        ) : (
                            <FormattedMessage
                                id={`members.member.errors.${memberId[1]}`}
                                values={{ identifier: this.getMemberName(memberId[0]) }}
                            />
                        ),
                        {
                            type: toast.TYPE.ERROR,
                            autoClose: false,
                        }
                    );
                });
            }
        }
    }

    getMemberName(memberId) {
        if (!this.props.members) return null;
        const member = this.props.members.find((member) => member.memberId == memberId);
        return member ? member.firstName + " " + member.lastName : null;
    }

    setCellClassNames(member) {
        return classNames({
            archived: member.isArchived,
        });
    }

    toggleInactivatedMembers() {
        const inactiveFiltered = this.state.filters.includes(MEMBER_TABLE.inactiveFilter);
        const filters = inactiveFiltered
            ? this.state.filters.filter((filter) => filter != MEMBER_TABLE.inactiveFilter)
            : [...this.state.filters, MEMBER_TABLE.inactiveFilter];
        this.getData(0, this.props.limit, this.props.q, this.props.sortBy, filters);
    }

    toggleArchivedMembers() {
        const isArchivedFiltered = this.state.filters.includes(MEMBERS.notArchivedFilter);
        const filters = isArchivedFiltered
            ? this.state.filters.filter((filter) => filter != MEMBERS.notArchivedFilter)
            : [...this.state.filters, MEMBERS.notArchivedFilter];
        this.getData(0, this.props.limit, this.props.q, this.props.sortBy, filters);
    }

    toggleAllCheckboxes(event) {
        const check = event.target.checked;
        const selection = [];

        for (let checkbox in this.checkboxes) {
            if (checkbox !== "master" && this.checkboxes.hasOwnProperty(checkbox) && this.checkboxes[checkbox]) {
                this.checkboxes[checkbox].checked = check;
                check && selection.push(checkbox);
            }
        }

        this.setState({ selection });
    }

    updateMasterCheckbox() {
        let checkAll = true;
        const selection = [];

        for (let checkbox in this.checkboxes) {
            if (checkbox !== "master" && this.checkboxes.hasOwnProperty(checkbox) && this.checkboxes[checkbox]) {
                if (this.checkboxes.hasOwnProperty(checkbox)) {
                    if (!this.checkboxes[checkbox].checked) {
                        checkAll = false;
                    } else {
                        selection.push(checkbox);
                    }
                }
            }
        }

        this.setState({ selection });
        this.checkboxes.master.checked = checkAll;
    }

    isSelected(memberId) {
        return this.state.selection.includes(memberId.toString());
    }

    generateMajorCards() {
        const dataToUpdate = this.state.selection.map((memberId) => ({
            memberId,
        }));

        const selectedMembers = this.props.members.filter((member) =>
            this.state.selection.includes(member.memberId.toString())
        );

        let memberNames = "";

        if (selectedMembers.length > 1) {
            for (let i = 0; i < selectedMembers.length; i++) {
                memberNames += selectedMembers[i].firstName + " " + selectedMembers[i].lastName + ", ";
            }

            memberNames = memberNames.slice(0, -2); // Removing last extra comma.
        } else {
            memberNames = selectedMembers[0].firstName + " " + selectedMembers[0].lastName;
        }

        const description = this.buildDescription(memberNames);

        const path = `${this.props.clientId}/major-cards-many`;

        return this.props.dataActions.postDataFile(CLIENTS, path, dataToUpdate, {}).then((data) => {
            if (data.type == types.POST_DATA_FILE_FAILURE) {
                toast.update(this.toastId, {
                    render: `${data.payload.error.data.error} - ${data.payload.error.data.message}`,
                    type: toast.TYPE.ERROR,
                    autoClose: downloaderEnums.AUTO_CLOSE,
                });
                throw new SubmissionError({
                    authorizationCode: {
                        messageKey: "validation.customMessages.serverErrors.wrongAuthorizationCode",
                        values: {},
                        state: "error",
                    },
                });
            } else {
                if (canDownload(description, this.props.currentDownloads)) {
                    this.setState({ downloadPath: this.props.shortLivedURL });
                    this.props.downloaderActions.downloadFile(
                        data.payload.data.fileUrl,
                        description,
                        undefined,
                        undefined,
                        true
                    );
                } else {
                    toast(
                        <FormattedMessage
                            id="downloader.duplicateDownload"
                            values={{ file: description, br: <br /> }}
                        />,
                        {
                            type: toast.TYPE.ERROR,
                            autoClose: downloaderEnums.AUTO_CLOSE,
                        }
                    );
                }
            }
        });
    }

    clearMembersForConfirmation() {
        this.props.selectedConfirmationMembersActions.clearMembers();
    }

    buildDescription(memberNames) {
        const userLanguage = localStorage.getItem("languageCode") || "en-CA";

        if (userLanguage == "fr-CA") {
            return frenchTranslations.downloader.memberMajorCard + ": " + memberNames;
        }

        return englishTranslations.downloader.memberMajorCard + ": " + memberNames;
    }

    updateMember(values) {
        const { memberId, firstName, lastName, memberGenderType, memberIdentifier, clientId } = values;
        const isAutomaticMemberIdentifier = this.props.isAutomaticMemberIdentifier;
        const dataToUpdate = {
            memberId,
            firstName,
            lastName,
            memberGenderType,
            memberIdentifier,
            clientId,
            isAutomaticMemberIdentifier,
        };
        return this.props.dataActions.updateDataItem(MEMBERS, dataToUpdate).then((data) => {
            if (
                data.type === types.UPDATE_DATA_ITEM_FAILURE &&
                data.payload.error.data.error === "duplicateMemberIdentifier"
            ) {
                throw new SubmissionError({
                    memberIdentifier: {
                        messageKey: "validation.customMessages.serverErrors.duplicateMemberIdentifier",
                        values: {},
                        state: "error",
                    },
                });
            } else {
                this.getData(this.props.offset, this.props.limit, this.props.q, this.props.sortBy, this.state.filters);
            }
        });
    }

    hasNoActiveMember() {
        if (!this.props.items) return true;
        const memberCoverages = this.props.items.map((item) => {
            const relevantCoverage = this.getMemberCoverage(item.memberCoverages, true);
            return !!relevantCoverage ? relevantCoverage : { isInactive: true };
        });
        return memberCoverages.every((coverage) => coverage.isInactive);
    }

    getMemberCoverage(coverages, includeFuture = false) {
        let relevantCoverage = null;
        const currentDate = new Date(
            new Date().toLocaleString("en-US", {
                timeZone: "UTC",
            })
        );
        if (!coverages) return null;

        coverages.forEach((coverage) => {
            const startDate = new Date(
                new Date(coverage.startDate).toLocaleString("en-US", {
                    timeZone: "UTC",
                })
            );
            let endDate = new Date(
                new Date(coverage.endDate).toLocaleString("en-US", {
                    timeZone: "UTC",
                })
            );
            endDate = new Date(endDate.setDate(endDate.getDate() + 1));

            if (startDate <= currentDate && (!coverage.endDate || endDate > currentDate)) {
                relevantCoverage = coverage;
                return;
            }
            if (includeFuture && startDate > currentDate && !coverage.isInactive) {
                relevantCoverage = coverage;
                return;
            }
        });
        return relevantCoverage;
    }

    handleMemberCheckBox(e, member) {
        const { selectedBillingPeriod } = this;
        const { clientName } = this.props;

        if (e.target.checked) {
            this.props.selectedConfirmationMembersActions.addMember({
                startDate: selectedBillingPeriod.startDate,
                endDate: selectedBillingPeriod.endDate,
                memberId: e.target.value,
                clientName: clientName,
                memberIdentifier: member.memberIdentifier,
                firstName: member.firstName,
                lastName: member.lastName,
            });
        } else {
            this.props.selectedConfirmationMembersActions.removeMember({
                startDate: selectedBillingPeriod.startDate,
                endDate: selectedBillingPeriod.endDate,
                memberId: e.target.value,
            });
        }
    }

    verifyCheckedMember(memberId) {
        const { checkedMembers } = this.props;
        const { selectedBillingPeriod } = this;
        let found = false;

        if (checkedMembers && selectedBillingPeriod) {
            found = checkedMembers.find(
                (member) =>
                    member.memberId == memberId &&
                    selectedBillingPeriod.startDate == member.startDate &&
                    selectedBillingPeriod.endDate == member.endDate
            );
        }

        return !!found;
    }

    getCols() {
        const { businessAccountType } = this.props;
        const tooltip = (
            <Tooltip id="tooltip" className="member-line-tooltip">
                <FormattedMessage id="members.member.actions.generateAll" />
            </Tooltip>
        );
        this.confirmationCheckboxes = {};

        const syncCol = canViewSyncStatus(this.props.activeClient, MEMBER) ? {
            name: <FormattedMessage id="members.datatable.columns.sync" />,
            display: (member) => {
                const { latestSyncs } = this.state;

                if (!latestSyncs) {
                    return <RectangleSpinner className="spinner-rect-col" />;
                }
                const latestMemberSyncs = latestSyncs["memberSyncs"];
                const latestMemberSync = latestMemberSyncs.find((e) => e.memberId == member.memberId);
                const data = { "member": _.cloneDeep(member), "client": this.props.activeClient };
                return getOverlayForSync(data, latestMemberSync, "members.datatable", "memberPartnerHash", "memberHash", "member");
            },
            widthPct: 8,
        } : undefined;
        // Show activation status column only for GM clients when sync status can be viewed
   const activationStatusCol = canViewActivationStatus(this.props.clientBillingPeriodType, this.props.isMintEnabled, this.props.syncType)
  ? {
      name: <FormattedMessage id="members.datatable.columns.activationStatus" />,
      display: (member) => {
        const { activationStatuses } = this.state;
        const warning = member.completeButNotActivated && !member.isArchived ? (
          <OverlayTrigger
            placement="top"
            overlay={
              <Tooltip id={`members-activation-warning-${member.memberId}`}>
                <FormattedMessage id="members.completeButNotActivatedWarning" />
              </Tooltip>
            }
          >
            <span className="activation-warning-pill">
              <span className="icon icon-warning" />
            </span>
          </OverlayTrigger>
        ) : null;

        if (member.emailVerified === true) {
          return (
            <div className="activation-status-wrapper">
              <div className="status status-indicator status-verified">
                <span>
                  <FormattedMessage id="status.emailVerified" />
                </span>
              </div>
              {warning}
            </div>
          );
        }
        if (!activationStatuses) {
          return <RectangleSpinner className="spinner-rect-col" />;
        }

        let mintEmail = activationStatuses[member.memberId];
        const isEmailVerified = mintEmail && mintEmail === member.emailAddress;

        const statusClass = `status status-indicator status-${isEmailVerified ? "verified" : "not-verified"}`;
        const statusKey = isEmailVerified ? "status.emailVerified" : "status.emailNotVerified";

        return (
          <div className="activation-status-wrapper">
            <div className={statusClass}>
              <span>
                <FormattedMessage id={statusKey} />
              </span>
            </div>
            {warning}
          </div>
        );
      },
      widthPct: 15,
    }
  : undefined;

        let cols = [
            {
                name: <FormattedMessage id="members.datatable.columns.member" />,
                sortKeys: ["firstName", "lastName"],
                display: (member) => (
                    <Link
                        to={`dashboard/clients/${member.client.clientId}/members/${member.memberId}`}
                        title={`${member.firstName} ${member.lastName}`}
                    >
                        <span
                            className={this.setCellClassNames(member)}
                        >{`${member.firstName} ${member.lastName}`}</span>
                    </Link>
                ),

                widthPct: 23,
            },
            {
                name: <FormattedMessage id="members.datatable.columns.memberIdentifier" />,
                key: "memberIdentifier",
                display: (member) => <span className={this.setCellClassNames(member)}>{member.memberIdentifier}</span>,
                widthPct: 16,
            },
            {
                name: <FormattedMessage id="members.datatable.columns.age" />,
                key: "birthdate",
                reverseSortOrder: true,
                display: (member) => (
                    <span className={this.setCellClassNames(member)}>
                        {moment().diff(member.birthdate, "years") || <FormattedMessage id="common.unknown" />}
                    </span>
                ),
                widthPct: 8,
            },
            {
                name: <FormattedMessage id="members.datatable.columns.status" />,
                display: (member) => (
                    <MemberCoverageStatus
                        businessAccountType={businessAccountType}
                        memberCoverage={this.getMemberCoverage(member.memberCoverages)}
                        authLanguageCode={this.props.authLanguageCode}
                    />
                ),
                widthPct: 10,
            },
            syncCol,
            activationStatusCol,
            {
                name: <FormattedMessage id="datatable.actions" />,
                display: (member) => this.generateActionButtons(member),
                widthPct: 12,
            },
            this.props.clientStatusType !== INACTIVE.value &&
                this.props.clientBillingPeriodType !== MANUAL.value &&
                this.props.syncType != TED_DESJARDINS.value
                ? {
                      name: (
                          <div className="generate-card">
                              <div className="checkbox-header">
                                  <OverlayTrigger placement="bottom" overlay={tooltip}>
                                      <input
                                          ref={(ref) => (ref ? (this.checkboxes["master"] = ref) : null)}
                                          type="checkbox"
                                          onChange={this.toggleAllCheckboxes}
                                          disabled={this.hasNoActiveMember()}
                                      />
                                  </OverlayTrigger>
                              </div>
                          </div>
                      ),
                      display: (member) => {
                          if (member.memberCoverages && member.memberCoverages.length) {
                              const relevantCoverage = this.getMemberCoverage(member.memberCoverages, true);
                              if (!!relevantCoverage && !relevantCoverage.isInactive && !member.isArchived) {
                                  const tooltip = (
                                      <Tooltip id="tooltip" className="member-line-tooltip">
                                          <FormattedMessage id="members.member.actions.description" />
                                      </Tooltip>
                                  );

                                  return (
                                      <OverlayTrigger placement="bottom" overlay={tooltip}>
                                          <input
                                              ref={(ref) => (ref ? (this.checkboxes[member.memberId] = ref) : null)}
                                              type="checkbox"
                                              value={member.memberId}
                                              onChange={this.updateMasterCheckbox}
                                              checked={this.isSelected(member.memberId)}
                                          />
                                      </OverlayTrigger>
                                  );
                              }
                          }
                      },
                      widthPct: 8,
                  }
                : {
                      name: "",
                      display: () => null,
                      widthPct: 8,
                  },
        ].filter(Boolean);
        
        // Dynamically adjusts the width of datatable as per column width
        const totalWidth = cols.reduce((sum, col) => sum + col.widthPct, 0);
        if (totalWidth < 100) {
            const diff = 100 - totalWidth;
            cols = cols.map((col) => ({
                ...col,
                widthPct: col.widthPct + (col.widthPct / totalWidth) * diff,
            }));
        }

        if (businessAccountType === PM.value) {
            cols.unshift({
                name: "",
                display: (member) => (
                    <input
                        ref={(ref) => (ref ? (this.confirmationCheckboxes[member.memberId] = ref) : null)}
                        type="checkbox"
                        value={member.memberId}
                        checked={this.verifyCheckedMember(member.memberId)}
                        onChange={(e) => this.handleMemberCheckBox(e, member)}
                    />
                ),
                widthPct: 3,
            });
        }

        return cols.filter((col) => col !== undefined);
    }
    renderFormatedMessage(icon) {
        return <span className="icon warning">{icon}</span>;
    }
    generateActionButtons(member) {
        const { isAutomaticMemberIdentifier, businessAccountType, clientNumber, clientStatusType } = this.props;
        const isMemberArchived = member && member.isArchived && !userHasAccess(FINTECH);
        const isAllowed = this.getCanModifyOrCreateForClientStatusType(clientStatusType);
        const viewOnly = !isAllowed || isMemberArchived || !(member.isEditable && isAllowed);
        return (
            <ButtonToolbar key={member.memberId}>
                <EditButton
                    title={<FormattedMessage id={`members.datatable.actions.${viewOnly ? "view" : "edit"}`} />}
                    label={<FormattedMessage id={viewOnly ? "common.view" : "common.edit"} />}
                    confirmationTitle={
                        <FormattedMessage id="admin.blocs.datatable.actions.showConfirm.title">
                            {this.renderFormatedMessage}
                        </FormattedMessage>
                    }
                    confirmationMessage={<FormattedMessage id="admin.blocs.datatable.actions.showConfirm.message" />}
                    closeButtonKey="common.cancel"
                    form={BasicMemberFields}
                    allowSubmission={!viewOnly}
                    props={{ disabled: viewOnly }}
                    data={{
                        client: {
                            isAutomaticMemberIdentifier: isAutomaticMemberIdentifier,
                            businessAccountType: businessAccountType,
                            clientNumber: clientNumber,
                        },
                        memberId: member.memberId,
                        firstName: member.firstName,
                        lastName: member.lastName,
                        memberGenderType: member.memberGenderType,
                        memberIdentifier: member.memberIdentifier,
                    }}
                    editFunction={this.updateMember}
                    requiresCloseConfirmation={true}
                    confirmOnClose={true}
                />
            </ButtonToolbar>
        );
    }

    getConfirmationMembersForPeriod() {
        const { selectedBillingPeriod } = this;
        const { checkedMembers } = this.props;

        let members = null;

        if (selectedBillingPeriod) {
            members = checkedMembers
                .map((member) => {
                    if (
                        member.startDate === selectedBillingPeriod.startDate &&
                        member.endDate === selectedBillingPeriod.endDate
                    ) {
                        return member;
                    }
                    return null;
                })
                .filter((member) => member);
        }

        return members;
    }

    generateAddButton(clientId) {
        const { selection } = this.state;
        const {
            clientStatusType,
            clientBillingPeriodType,
            isAutomaticMemberIdentifier,
            businessAccountType,
            checkedMembers,
            clientNumber,
            syncType
        } = this.props;

        const userLanguage = localStorage.getItem("languageCode") || "en-CA";
        const confirmationMembers = this.getConfirmationMembersForPeriod();
        const allowSubmission = clientNumber && clientNumber.length > 0;
        return (
                <div>
                    {clientStatusType !== TERMINATED.value && (
                    <div className="members-actions">
                        <Render for={AGENT} exactly={PLAN_ADMINISTRATOR}>
                            <EditButton
                                title={<FormattedMessage id="members.datatable.actions.add" />}
                                label={<FormattedMessage id="common.add" />}
                                add={true}
                                form={BasicMemberFields}
                                data={{
                                    client: {
                                        clientId: clientId,
                                        isAutomaticMemberIdentifier: isAutomaticMemberIdentifier,
                                        businessAccountType: businessAccountType,
                                        clientNumber: clientNumber,
                                    },
                                    firstName: "",
                                    lastName: "",
                                    isEditable: false,
                                }}
                                allowSubmission={allowSubmission}
                                editFunction={this.createMember}
                                confirmationTitle={
                                    <FormattedMessage id="admin.blocs.datatable.actions.showConfirm.title">
                                        {this.renderFormatedMessage}
                                    </FormattedMessage>
                                }
                                confirmationMessage={
                                    <FormattedMessage id="admin.blocs.datatable.actions.showConfirm.message" />
                                }
                                closeButtonKey="common.cancel"
                                requiresCloseConfirmation={true}
                                confirmOnClose={true}
                            />
                        </Render>
                        <Render
                            if={
                                !RESTRICTED_STATUSES.includes(clientStatusType) &&
                                clientBillingPeriodType !== MANUAL.value &&
                                syncType != TED_DESJARDINS.value
                            }
                        >
                            <span>
                                <GenerateMajorCardButton
                                    datatableActionButton={false}
                                    title={<FormattedMessage id="common.generate" />}
                                    label={<FormattedMessage id="members.member.actions.majorCard" />}
                                    download={true}
                                    editFunction={this.generateMajorCards}
                                    disabled={!selection.length}
                                />
                            </span>
                        </Render>
                        <Render
                            if={
                                clientBillingPeriodType == "MANUAL" &&
                                businessAccountType == PM.value &&
                                clientStatusType !== INACTIVE.value &&
                                !userHasAccess(HR_CLERK, true)
                            }
                        >
                            <span>
                                <GenerateCoverageConfirmationButton
                                    title={<FormattedMessage id="common.generate" />}
                                    label={<FormattedMessage id="members.datatable.actions.coverageConfirmations" />}
                                    disabled={checkedMembers.length == 0}
                                    billingPeriod={this.selectedBillingPeriod}
                                    clientId={this.props.clientId}
                                    clientName={this.props.clientName}
                                    clearMembersForConfirmation={this.clearMembersForConfirmation}
                                />
                            </span>
                        </Render>
                    </div>                 
                    )}
                    <CheckboxButton
                        className="include-archived"
                        id="archived"
                        label={<FormattedMessage id="members.datatable.actions.includeArchivedMembers" />}
                        checked={
                            this.state.filters.includes(MEMBERS.archivedFilter) ||
                            !this.state.filters.includes(MEMBERS.notArchivedFilter)
                        }
                        onClick={this.toggleArchivedMembers}
                    />
                    <CheckboxButton
                        className="include-archived"
                        id="inactive"
                        label={<FormattedMessage id="members.datatable.actions.includeInactiveMembers" />}
                        checked={
                            !this.state.filters.includes(MEMBER_TABLE.inactiveFilter) &&
                            !this.state.filters.includes(MEMBERS.archivedFilter)
                        }
                        onClick={this.toggleInactivatedMembers}
                    />
                    {this.selectedBillingPeriod && this.selectedBillingPeriod.localizations && clientStatusType !== TERMINATED.value && (
                        <Render
                            if={
                                clientBillingPeriodType == "MANUAL" &&
                                businessAccountType == PM.value &&
                                clientStatusType !== INACTIVE.value && 
                                !userHasAccess(HR_CLERK, true)
                            }
                        >
                            <a
                                onClick={() => this.setState({ showConfirmationCoverageModal: true })}
                                className="selected-members"
                            >
                                <span>
                                    <FormattedMessage
                                        id="members.datatable.actions.numberOfMembersSelectedForPeriod"
                                        values={{
                                            membersCount: confirmationMembers.length.toString(),
                                            period: this.selectedBillingPeriod.localizations[userLanguage].name,
                                        }}
                                    />
                                </span>
                            </a>
                        </Render>
                    )}
                </div>
            );
    }

    generateFilterButton() {
        const { formatMessage } = this.context.intl;
        const options = this.props.billingPeriods.map((period) => {
            return {
                value: period.billingPeriodId,
                text: period.localizations[this.props.authLanguageCode].name,
            };
        });
        const defaultValue = options[0] ? options[0].value : null;

        return this.props.billingPeriodsFetched ? (
            <BillingPeriodFilter
                initialValues={{ billingPeriodFilter: defaultValue }}
                onChange={this.updateBillingPeriodFilter}
                options={[
                    {
                        value: NEW_MEMBERS,
                        text: formatMessage({ id: "members.datatable.actions.newMembers" }),
                    },
                    ...options,
                ]}
            />
        ) : (
            ""
        );
    }

    getData(offset, limit, q, sortBy, filters) {
        if (this.checkboxes.master) {
            this.checkboxes = { master: this.checkboxes.master };
            this.checkboxes.master.checked = false;
        } else {
            this.checkboxes = {};
        }

        this.setState({ selection: [], latestSyncs: null, activationStatuses: null });

        const model = {
            path: `/v1/clients/${this.props.clientId}/get-last-generated-member`,
        };

        this.props.dataActions.simplePost({ model }).then((data) => {
            this.props.clientActions.setLastGeneratedMember(data.payload.data);
        });

        return (
            this.props.billingPeriodsFetched &&
            this.props.dataActions
                .getDataList(
                    MEMBER_TABLE,
                    offset,
                    limit,
                    q,
                    sortBy,
                    filters,
                    null,
                    { clientId: this.props.clientId },
                    "memberCoverages(memberCoverageGuarantees(*),*),*"
                )
                .then((res) => {
                    const memberIds = res.payload.data.items.map((m) => m.memberId);
                    if (canViewSyncStatus(this.props.activeClient, MEMBER)) {
                        getLatestMemberSyncsV2(this.props.clientId, memberIds, true)
                            .then((response) => {
                                this.setState({ latestSyncs: response });
                            }
                            );
                    }
                    if (canViewActivationStatus(this.props.clientBillingPeriodType, this.props.isMintEnabled, this.props.syncType)) {
                        this.fetchActivationStatuses(memberIds);
                    }
                }).catch(() => {
                    toast(<FormattedMessage id="validation.customMessages.serverErrors.genericError" />, {
                        type: toast.TYPE.ERROR,
                        autoClose: false,
                    });
                })
        );
    }

    fetchActivationStatuses(memberIds) {
        // Only fetch if we have member IDs
        if (!memberIds || memberIds.length === 0 || this.props.clientBillingPeriodType !== RECURRING.value) {
            return;
        }
        getBatchMemberActivationStatuses(this.props.clientId, memberIds)
            .then((statusArr) => {
                const members = statusArr["members"];
                const activationStatuses = {};
                members.forEach((m) => {
                    if(m.email_verified) activationStatuses[m.msys_member_id] = m.email_address;
                });
                this.setState({ activationStatuses });
            })
            .catch(() => {
                toast(<FormattedMessage id="validation.customMessages.serverErrors.genericError" />, {
                    type: toast.TYPE.ERROR,
                    autoClose: false,
                });
            });
    }

    updateBillingPeriodFilter(event) {
        if (event.target) {
            const billingPeriodId = event.target.value;
            this.selectedBillingPeriod = this.props.billingPeriods.find(
                (element) => element.billingPeriodId == billingPeriodId
            );
            let filters = this.state.filters.filter(
                (filter) => filter.includes("members.clientId") || filter.includes(MEMBERS.notArchivedFilter)
            );

            if (billingPeriodId == NEW_MEMBERS) {
                filters.includes(MEMBER_TABLE.inactiveFilter) &&
                    filters.splice(filters.indexOf(MEMBER_TABLE.inactiveFilter));
                filters.push(`memberCoverages.memberCoverageId==null`);
            } else {
                this.props.businessAccountType == GM.value &&
                    !filters.includes(MEMBER_TABLE.inactiveFilter) &&
                    filters.push(MEMBER_TABLE.inactiveFilter);
                if (this.props.clientBillingPeriodType === "MANUAL") {
                    filters.push(`billingPeriodId==${billingPeriodId}`);
                } else {
                    const billingPeriod = this.props.billingPeriods.find(
                        (period) => period.billingPeriodId == billingPeriodId
                    );
                    filters.push(`billingPeriodId==null`);
                    billingPeriod && filters.push(`startDate<=${billingPeriod.endDate}`);
                    billingPeriod && filters.push(`(endDate==null,endDate>=${billingPeriod.startDate})`);
                }
            }
            const customOffset = 0;

            if (!_.isEqual(this.state.filters, filters)) {
                this.setState({ filters });
                this.getData(customOffset, this.props.limit, this.props.q, this.props.sortBy, filters);
            }
        }
    }

    getCanModifyOrCreateForClientStatusType(clientStatusType) {
        switch (clientStatusType) {
            case IMPLEMENTATION.value:
                return this.canModifyOrCreateForImplementation;
            case ACTIVE.value:
            case INACTIVE.value:
                return this.canModifyOrCreateForActive;
            case TERMINATED.value:
                return this.canModifyOrCreateForTerminated;
        }
    }

    render() {
        return (
            <div>
                <DataTable
                    ref="dataTable"
                    title={<FormattedMessage id="members.title" />}
                    getData={this.getData}
                    cols={this.getCols()}
                    q={this.props.q}
                    filters={this.state.filters}
                    offset={this.props.offset}
                    data={this.props.items}
                    rowsPerPage={this.props.limit}
                    totalRows={this.props.total}
                    sortBy={this.props.sortBy}
                    addButton={this.generateAddButton(this.props.clientId)}
                    filterButtons={this.generateFilterButton()}
                    refreshFunction={this.getData}
                />
                <Render if={!userHasAccess(HR_CLERK, true)}>
                    <MembersGenerateCoverageModal
                        onClose={() => this.setState({ showConfirmationCoverageModal: false })}
                        showMembersModal={this.state.showConfirmationCoverageModal}
                        clearMembersList={this.clearMembersForConfirmation}
                        members={this.getConfirmationMembersForPeriod()}
                    />
                </Render>
            </div>
        );
    }
}

MembersDataTable.propTypes = {
    authLanguageCode: PropTypes.string.isRequired,
    billingPeriods: PropTypes.array,
    billingPeriodsFetched: PropTypes.bool,
    dataActions: PropTypes.object,
    filters: PropTypes.array,
    q: PropTypes.string,
    items: PropTypes.array,
    limit: PropTypes.number,
    offset: PropTypes.number,
    sortBy: PropTypes.array,
    total: PropTypes.number,
    clientStatusType: PropTypes.string,
    clientBillingPeriodType: PropTypes.string,
    syncType: PropTypes.string,
    isAutomaticMemberIdentifier: PropTypes.bool,
    businessAccountType: PropTypes.number,
    clientId: PropTypes.number,
    statuses: PropTypes.array,
    insuranceTypes: PropTypes.array,
    shortLivedURL: PropTypes.string,
    cookieName: PropTypes.string,
    getLastGeneratedMember: PropTypes.number,
    clientActions: PropTypes.object,
    checkedMembers: PropTypes.array,
    clientName: PropTypes.string,
    members: PropTypes.array,
    selectedConfirmationMembersActions: PropTypes.object,
    isArchived: PropTypes.bool,
    currentDownloads: PropTypes.array,
    downloaderActions: PropTypes.object,
    successDownloads: PropTypes.array,
    errorDownloads: PropTypes.array,
    clientNumber: PropTypes.string,
    activeClient: PropTypes.object,
    isMintEnabled: PropTypes.bool,
};

MembersDataTable.contextTypes = {
    intl: intlShape,
};

function mapStateToProps(state) {
    const billingPeriods = state.data.billingPeriods || {};
    const data = state.data.members || {};
    const newClient = data.clientId != state.data.clients.active.clientId;
    const pagination = data.pagination || {};
    const shortLivedURL = data.shortLivedURL || {};
    const downloads = state.downloader || {};
    const checkedMembers = state.selectedConfirmationMembers || {};

    return {
        authLanguageCode: state.auth.user.languageCode,
        activeClient: state.data.clients.active,
        billingPeriods: billingPeriods.items || [],
        billingPeriodsFetched: !!billingPeriods.fetched,
        clientStatusType: state.data.clients.active.clientStatusType,
        clientBillingPeriodType: state.data.clients.active.clientBillingPeriodType,
        isAutomaticMemberIdentifier: state.data.clients.active.isAutomaticMemberIdentifier,
        clientId: state.data.clients.active.clientId,
        clientName: state.data.clients.active.fullName,
        clientNumber: state.data.clients.active.clientNumber,
        businessAccountType: state.data.clients.active.businessAccountType,
        syncType: state.data.clients.active.syncType,
        q: data.q,
        filters: newClient
            ? [
                `members.clientId==${state.data.clients.active.clientId}`,
                MEMBERS.notArchivedFilter,
                MEMBER_TABLE.inactiveFilter,
            ]
            : data.filters,
        members: data.items || [],
        limit: pagination.limit || memberPageSize,
        offset: pagination.offset || 0,
        sortBy: data.sortBy || ["firstName:asc", "lastName:asc"],
        total: pagination.totalCount || 0,
        items: data.items || null,
        shortLivedURL: shortLivedURL.fileUrl || null,
        cookieName: shortLivedURL.cookieName || null,
        currentDownloads: downloads.files || [],
        errorDownloads: downloads.errorDownloads || [],
        successDownloads: downloads.successDownloads || [],
        checkedMembers: checkedMembers.data || [],
        isArchived: state.data.clients.active.isArchived,
        isMintEnabled: state.clientActions.isMintEnabled,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        dataActions: bindActionCreators(dataActions, dispatch),
        clientActions: bindActionCreators(clientActions, dispatch),
        downloaderActions: bindActionCreators(downloaderActions, dispatch),
        selectedConfirmationMembersActions: bindActionCreators(selectedConfirmationMembersActions, dispatch),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(MembersDataTable);



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/members/MembersDataTable.js